import apiClient from 'utilities/apiClient';

// get_Countrycodes
export const get_Countrycodes = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.mastersdata}/${url}`, payload, true);
};

// occupation_Data
export const occupation_Data = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.mastersdata}/${url}`, payload, true);
};

// get_MStatus
export const get_MStatus = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.mastersdata}/${url}`, payload, true);
};

//  get_FamilyStatus
export const get_FamilyStatus = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.mastersdata}/${url}`, payload, true);
};

// get_FamilyValue
export const get_FamilyValue = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.mastersdata}/${url}`, payload, true);
};

// get_FamilyType
export const get_FamilyType = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.mastersdata}/${url}`, payload, true);
};

// create_family
export const create_family = (url, payload) => {
  return apiClient.patch(
    `${apiClient.Urls.createdetails}/${url}`,
    payload,
    true
  );
};

export const detailsList = (payload) => {
  return apiClient.get(`${apiClient.Urls.listView}/${payload}`, payload, true);
};

// delete_siblings
export const delete_siblings = (url, payload) => {
  return apiClient.patch(
    `${apiClient.Urls.createdetails}/${url}`,
    payload,
    true
  );
};
